export default {
  title: '申请状态变更通知管理',
  menu: '申请状态变更通知管理',
  label: {
    status: '简历状态',
    emailTemplateToEmployeeCandidateName: '发送给候选人（员工）',
    emailTemplateToCandidateName: '发送给候选人（非员工）',
    hasConfig: {
      has: '已配置',
      not: '未配置'
    },
    emailTemplateToReferrerName: '发送给推荐人（员工）'
  },
  placeholder: {
    emailTemplateTo: '请选择'
  },
  btn: {
    deleteConfig: '删除',
    saveConfig: '保存',
    addConfig: '添加'
  },
  message: {
    deleteSuccess: '删除成功',
    cannotSaveEmpty: '请至少配置一条锁定规则',
    checkConfigList: '配置内容有误，请检查'
  }
}
